import type React from "react";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { Page as Component } from "~/components/specifics/vendors/settings/vendor_users/Page";

export const Page: React.FC = () => (
	<VendorLayoutV2>
		<Component />
	</VendorLayoutV2>
);
